var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChartNormal',{attrs:{"size":"12","offset":"0","title":"Beyond Economical Repair","chart":"column","chartType":"BER","isCity":false,"withDate":true,"withFinancial":false,"showExcel":true,"type":"ber"}})}
var staticRenderFns = []

export { render, staticRenderFns }